/** « Le compte » : ressources à gauche, dépenses à droite, solde financé par emprunt au taux du moment (PRD §11). */
import type { YearState } from "../../../engine/src/types.js";
import { escapeHtml as e, num, pct } from "../format.js";

const f0 = (x: number) => (Math.abs(x) < 0.5 ? "0" : num(x, 0));

export function ledgerHtml(y: YearState, engineName: string): string {
  const a = y.account;
  const tr = a.resources.reduce((s, l) => s + l.amount, 0);
  const td = a.expenses.reduce((s, l) => s + l.amount, 0);
  const col = (title: string, rows: typeof a.resources, tot: number, cls: string) =>
    `<div><div class="lh">${title}</div>${rows
      .filter((r) => Math.abs(r.amount) >= 0.05)
      .map((r) => `<div class="lr"><span>${e(r.label)}</span><b class="${r.amount <= -0.5 ? "down" : ""}">${f0(r.amount)}</b></div>`)
      .join("")}<div class="lr lt"><span>Total</span><b class="${cls}">${f0(tot)}</b></div></div>`;
  const marginal = y.kpis.marginal_rate_pct;
  const apparent = y.kpis.apparent_rate_pct;
  return `<div class="ledger">${col("Ressources (Md€)", a.resources, tr, "up")}${col("Dépenses (Md€)", a.expenses, td, "down")}</div>
  <div class="bal">
    <div><div class="l">Solde des administrations publiques ${y.year}</div><div class="v ${a.balance_apu < 0 ? "down" : "up"}">${a.balance_apu < 0 ? "−" : "+"}${num(Math.abs(a.balance_apu), 0)} Md€</div><div class="l">État ${f0(a.balance_state)} · Sécu ${f0(a.balance_asso)} · collectivités ${f0(a.balance_apul)}</div></div>
    <div><div class="l">Financé par emprunt à</div><div class="v">${marginal !== undefined ? pct(marginal, 2) : "—"}</div><div class="l">${apparent !== undefined ? `taux apparent du stock ${pct(apparent, 2)}` : ""}</div></div>
  </div>
  <p class="hint">Lignes calculées par ${e(engineName)}. Une dépense s'affiche en positif ; un besoin Sécu/collectivités est leur déficit repris par l'ensemble public.</p>`;
}
